import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { DEAUTHENTICATE, AUTHENTICATE } from './actions.js';
import { onMapDeauthenticatedState, onMapAuthenticatedState } from './events.js';

var getInitialState = function getInitialState() {
  return {
    loggedIn: false
  };
};

var auth = function auth() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialState();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case AUTHENTICATE:
      return _objectSpread2(_objectSpread2({}, state), onMapAuthenticatedState(action.result));

    case DEAUTHENTICATE:
      return _objectSpread2(_objectSpread2({}, state), onMapDeauthenticatedState(action.result));

    default:
      return state;
  }
};

export { auth as default };
